"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotableDocumentClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const annotable_document_serializer_1 = require("../serializers/annotable-document.serializer");
const delete_annotable_document_serializer_1 = require("../serializers/delete-annotable-document.serializer");
const get_1 = __importDefault(require("lodash/get"));
class AnnotableDocumentClient {
    static newInstance(options, retryOptions) {
        return new AnnotableDocumentClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new annotable_document_serializer_1.AnnotableDocumentSerializer(), new delete_annotable_document_serializer_1.DeleteAnnotableDocumentSerializer());
    }
    constructor(client, serializer, deleteSerializer) {
        this.client = client;
        this.serializer = serializer;
        this.deleteSerializer = deleteSerializer;
    }
    async save(annotableDocuments, headers) {
        const response = await this.client.post(`/annotableDocuments.save`, annotableDocuments, {
            headers,
        });
        return this.serializer.serialize(response.body);
    }
    async saveOne(annotableDocument, headers) {
        const response = await this.client.post(`/annotableDocuments`, annotableDocument, {
            headers,
        });
        return this.serializer.serializeOne(response.body);
    }
    async findOne(annotableDocumentId, headers) {
        const response = await this.client.get(`/annotableDocuments/${annotableDocumentId}`, {
            headers,
        });
        const { data } = response.body;
        return this.serializer.serializeOne(data);
    }
    async findByIds(documentIds, parentId, parentType, resourceId, headers) {
        const response = await this.client.get(`/annotableDocuments.findByIds`, {
            headers,
            params: {
                documentIds,
                parentId,
                parentType,
                resourceId,
            },
        });
        return this.serializer.serialize(response.body);
    }
    async findByContentId(contentIds, parentId, parentType, resourceId, headers) {
        const response = await this.client.get(`/annotableDocuments.findByContentId`, {
            headers,
            params: {
                contentId: contentIds,
                parentId,
                parentType,
                resourceId,
            },
        });
        if (response.status === 204) {
            throw response;
        }
        return this.serializer.serialize(response.body);
    }
    async findByOrCreate(annotableDocuments, parentId, parentType, headers) {
        const documents = [];
        for (let document of annotableDocuments) {
            const contentId = document.contentId;
            const parentId = document.parentId;
            const parentType = document.parentType;
            const resourceId = document.resourceId;
            try {
                const documentFound = await this.findByContentId([contentId], parentId, parentType, resourceId, headers);
                documents.push(...(0, get_1.default)(documentFound, 'data', []));
            }
            catch (e) {
                const createdDocument = await this.saveOne(document, headers);
                documents.push((0, get_1.default)(createdDocument, 'data', {}));
            }
        }
        return documents;
    }
    async complete(id, headers) {
        const response = await this.client.put(`/annotableDocuments.complete/${id}`, {}, {
            headers,
        });
        return this.serializer.serializeOne(response.body);
    }
    async delete(documentId, headers) {
        await this.client.delete(`/annotableDocuments/${documentId}`, {
            headers,
        });
    }
    async markMultipleAsDraft(documentsAsDraftDto, headers) {
        const response = await this.client.put(`/annotableDocuments.markMultipleAsDraft`, documentsAsDraftDto, {
            headers,
        });
        return this.serializer.serialize(response.body);
    }
    async bulkDelete(annotableDocumentIds, headers) {
        const response = await this.client.put(`/annotableDocuments.bulkDelete`, {
            annotableDocumentIds,
        }, {
            headers,
        });
        return this.deleteSerializer.serialize(response.body);
    }
    async deleteByContentId(contentIds, headers) {
        await this.client.delete(`/annotableDocuments.deleteByContentId`, {
            headers,
            params: {
                contentId: contentIds,
            },
        });
    }
}
exports.AnnotableDocumentClient = AnnotableDocumentClient;
//# sourceMappingURL=annotable-document.client.js.map